export const STORE_PLATFORMS = {
  digikala: {
    title: "دیجی‌کالا",
    icon: null,
    img: "/media/socialIcon/40icon/pr/digikala.svg",
    colors: ["#ef394e", "#f25d6e", "#ffebee"],
    badgeColor: "#ef394e",
    defaultIcon: "mdi-shopping"
  },
  divar: {
    title: "دیوار",
    icon: "post-outline",
    img: "/media/socialIcon/40icon/pr/divar.svg",
    colors: ["#a62626", "#c62828", "#ffebee"],
    badgeColor: "#c62828",
    defaultIcon: "mdi-domain"
  },
  woocommerce: {
    title: "ووکامرس",
    icon: "shopping-outline",
    img: "/media/socialIcon/40icon/pr/samsung.svg", // یا آیکون اختصاصی ووکامرس
    colors: ["#7f54b3", "#96588a", "#ede7f6"],
    badgeColor: "#7f54b3",
    defaultIcon: "mdi-cart-outline"
  },
  physical_store: {
    title: "فروشگاه فیزیکی",
    icon: "store-24-hour",
    img: null,
    colors: ["#36E71B", "#094D04", "#98F3C1"],
    badgeColor: "#2e7d32",
    defaultIcon: "mdi-store"
  },
  general_settings: {
    title: "تنظیمات کلی",
    icon: "cog-outline",
    img: "/media/socialIcon/40icon/pr/tools.svg",
    colors: ["#5c6bc0", "#3949ab", "#e8eaf6"],
    badgeColor: "#3949ab",
    defaultIcon: "mdi-cog-outline"
  },
  technolife: {
    title: "تکنولایف",
    icon: "cellphone-link",
    img: "/media/socialIcon/40icon/pr/technolife.svg",
    colors: ["#26487e", "#3a5f9c", "#e7ebf2"],
    badgeColor: "#26487e",
    defaultIcon: "mdi-cellphone-link"
  }
};

export function getPlatformMeta(type) {
  return STORE_PLATFORMS[type] || {
    title: type || "فروشگاه",
    icon: "storefront",
    img: null,
    colors: ["#607d8b", "#78909c", "#eceff1"],
    badgeColor: "#607d8b",
    defaultIcon: "mdi-storefront"
  };
}
